import { Model } from 'dva'
import { TelephonyService } from '../../../Service'
import { IsObject } from '../../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'
import { Provider } from './types'

const Providers: Model = {
  namespace: 'providers',
  state: {
    list: [],
  },
  effects: {
    *list(
      { useCache = true, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let providers = yield select((state: any) => state.providers.list)
        if (!(providers.length > 0 && useCache)) {
          providers = yield call(TelephonyService.telephonyProvidersList, {})
          yield put({ type: 'modifyList', payload: providers })
        }
        onSuccess(providers)
      } catch (err: any) {
        FailureHandler('Error fetching providers', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let provider = yield select((state: any) =>
          state.providers.list.find((provider: Provider) => provider.id === id)
        )
        if (!provider) {
          provider = yield call(TelephonyService.telephonyProvidersRetrieve, { id: id })
        }
        yield put({ type: 'modifyList', payload: provider })
        onSuccess(provider)
      } catch (err) {
        FailureHandler('Could not find the provider!', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      { data = {}, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(TelephonyService.telephonyProvidersCreate, {
          requestBody: data,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error adding a provider', err, onFailure)
      }
      setLoading(false)
    },
    *partialUpdate(
      { id, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(TelephonyService.telephonyProvidersPartialUpdate, {
          id: id,
          requestBody: data,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing a provider', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        yield call(TelephonyService.telephonyProvidersDestroy, { id: id })
        yield put({ type: 'modifyList', payload: id })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting a provider', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: Provider) => l.id !== action.payload.id)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter((l: Provider) => !action.payload.map((p: Provider) => p.id).includes(l.id))
          .concat(action.payload)
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
        list = list.filter((l: Provider) => l.id !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetProviders(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default Providers
